import React from "react";

import { Grid } from "@material-ui/core";
import AverageDailyFootfallLevel from "./AverageDailyFootfallLevel";
import AverageDailyFootfallLevelMeasure from "./AverageDailyFootfallLevelMeasure";
import AverageDailyFootfallLevelTitle from "./AverageDailyFootfallLevelTitle";
import FootfallOverTime from "./FootfallOverTime";
import FootfallOverTimeMeasure from "./FootfallOverTimeMeasure";
import FootfallOverTimeTitle from "./FootfallOverTimeTitle";

const FootfallChangesOverTime: React.FC = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FootfallOverTimeTitle />
            </Grid>
            <Grid item xs={12}>
                <FootfallOverTimeMeasure />
            </Grid>
            <Grid item xs={12}>
                <FootfallOverTime />
            </Grid>
            <Grid item xs={12}>
                <AverageDailyFootfallLevelTitle />
            </Grid>
            <Grid item xs={12}>
                <AverageDailyFootfallLevelMeasure />
            </Grid>
            <Grid item xs={12}>
                <AverageDailyFootfallLevel />
            </Grid>
        </Grid>
    );
};

export default FootfallChangesOverTime;
